import React, { useState } from 'react';
import MenuItemCard from './MenuItemCard';
import './PartySetup.css';
import image1 from '../image/food1.jpg';
import MenuFilters from './MenuFilters';
import { RiArrowDropDownLine } from "react-icons/ri";


const mockMenu = [
    { id: 1, name: 'Corn Chaat', category: 'Starters', description: 'Corn Chaat is a deliciousv sjvcs fgfbbfnfnc svdhsv ajbbds bsbcsb hdjbjkbv  shnfa kscbdbdjdbvkjsd kjd dbvnksks dskvnsd More', image: image1 },
    { id: 2, name: 'Veg Soup', category: 'Soup', description: 'Corn Chaat is a deliciousv sjvcs fgfbbfnfnc svdhsv ajbbds bsbcsb hdjbjkbv  shnfa kscbdbdjdbvkjsd kjd dbvnksks dskvnsd More', image: image1 },
    { id: 3, name: 'Paneer Tikka', category: 'Starters', description: 'Corn Chaat is a deliciousv sjvcs fgfbbfnfnc svdhsv ajbbds bsbcsb hdjbjkbv  shnfa kscbdbdjdbvkjsd kjd dbvnksks dskvnsd More', image: image1 },
    { id: 4, name: 'Paneer Tikka', category: 'Starters', description: 'Corn Chaat is a deliciousv sjvcs fgfbbfnfnc svdhsv ajbbds bsbcsb hdjbjkbv  shnfa kscbdbdjdbvkjsd kjd dbvnksks dskvnsd More', image: image1 },
    { id: 5, name: 'Paneer Tikka', category: 'Starters', description: 'Corn Chaat is a deliciousv sjvcs fgfbbfnfnc svdhsv ajbbds bsbcsb hdjbjkbv  shnfa kscbdbdjdbvkjsd kjd dbvnksks dskvnsd More', image: image1 },
];

export default function PartySetup({ selectedItems, setSelectedItems }) {
    const handleToggle = (item) => {
        const alreadySelected = selectedItems.find((i) => i.id === item.id);
        if (alreadySelected) {
            setSelectedItems(selectedItems.filter((i) => i.id !== item.id));
        } else {
            setSelectedItems([...selectedItems, item]);
        }
    };

    const [activeTab, setActiveTab] = useState("menu");

    return (
        <div className="setup-card">
            <h3>Party Setup</h3>
            <div className=''>
                <div className="setup-m-header">
                    <div
                        className={`setup-m-header-add-tab ${activeTab === "menu" ? "active" : ""}`}
                        onClick={() => setActiveTab("menu")}
                    >
                        Add Menu
                    </div>
                    <div
                        className={`setup-m-header-add-tab ${activeTab === "guest" ? "active" : ""}`}
                        onClick={() => setActiveTab("guest")}
                    >
                        Add Guest
                    </div>
                </div>
            </div>
            <div>
                <MenuFilters/>
            </div>
            <div className="menu-section">
                <div className="menu-c-item-details">
                    <h4>Starters</h4>
                    <RiArrowDropDownLine size={20} />
                </div>
                {mockMenu.map((item) => (
                    <MenuItemCard
                        key={item.id}
                        item={item}
                        isSelected={!!selectedItems.find((i) => i.id === item.id)}
                        onToggle={handleToggle}
                        isDisabled={false}
                    />
                ))}
            </div>
            <button className="next-btn">Next to Add Guest</button>
        </div>
    );
}
